import { Mission } from "@/store/missions/models"
import _ from "lodash"
import React, { useState } from "react"
import { connect } from "react-redux"
import Slider, { Settings } from "react-slick"
import MissionListItem from "./MissionItem"
import MissionModal from "./MissionModal"
import style from "./style.scss"

interface MissionListProps {
  missions: Mission[] | null
  initialMission?: Mission
}

const getTutorialMission = (): Mission => {
  const mission = new Mission()

  mission.isTutorial = true
  mission.title = "Black Mirror tutorial"
  mission.description =
    "<p>Learn how to use this app in this one minute tutorial.</p><p>We'll take you through a few of Black Mirror's key tasks including video and emotional ratings.</p><p>This mission will always be available to you in case you run into trouble using the app.</p>"

  return mission
}

const MissionList: React.SFC<Readonly<MissionListProps>> = (props) => {
  const [modal, setModal] = useState<number>(-1)
  const [modalOpen, setModalOpen] = useState<boolean>(false)

  const openModal = (index?: number) => {
    if (typeof index !== "undefined") {
      setModal(index)
      setModalOpen(true)
    }
  }

  const missionsToDisplay =
    props.missions && props.missions.filter((i) => !i.isUnavailable())

  const settings = {
    dots: false,
    speed: 200,
    swipe: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: "20px",
    infinite: false,
    arrows: false,
    touchThreshold: 15,
    initialSlide:
      missionsToDisplay && props.initialMission
        ? missionsToDisplay.findIndex(
            (i) => i.id === props.initialMission!.id
          ) + 1
        : 0
  } as Settings

  return (
    <section className={style.missionList}>
      <Slider {...settings}>
        <MissionListItem openModal={openModal} mission={getTutorialMission()} />

        {missionsToDisplay &&
          missionsToDisplay.map((mission, index) => (
            <MissionListItem
              key={index}
              index={index}
              mission={mission}
              openModal={openModal}
            />
          ))}
      </Slider>

      {missionsToDisplay && (
        <MissionModal
          instructions={
            missionsToDisplay[modal] && missionsToDisplay[modal].instructions
          }
          body={missionsToDisplay[modal] && missionsToDisplay[modal].webpage}
          modalOpen={modalOpen}
          closeModal={() => setModalOpen(false)}
        />
      )}
    </section>
  )
}

export default connect(
  null,
  null
)(MissionList)
